import Vue from "vue";
import { Component } from "vue-property-decorator";
import $ from "jquery";
import moment from "moment";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalAlerte/modalAlerte";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { DemandeFichierVirementsSepaDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeFichierVirementsSepaDto";

@Component
export default class ModalVirementSepa extends Vue {

    public societeCourante?: SocieteDto = undefined;

    public moisExercice?: number = undefined;
    public anneeExercice?: number = undefined;
    public dateEffetVirementSepa?: string = undefined;

    public isLoading = true;

	public init(): void {
    	const societe = ParametresInstance.societeCourante;
    	if (societe != undefined && societe.PeriodeActive != undefined) {
    		this.initSociete();
        }

    	EventBus.$on(EventConstants.SOCIETE_CHANGED, (e) => {
    		const societe = e as SocieteDto;
    		if (societe != undefined && societe.PeriodeActive != undefined) {
    			this.initSociete();
    		}
    	});
    	if (this.isLoading) {
			this.isLoading = false;
		}

        $("#modalVirementSepa").modal("show");
	}

    public initSociete(): void {

        if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.PeriodeActive == undefined) {
            this.societeCourante = undefined;
            this.moisExercice = undefined;
            this.anneeExercice = undefined;
            this.dateEffetVirementSepa = undefined;
            return;
        }

        this.societeCourante = ParametresInstance.societeCourante;
        this.moisExercice = ParametresInstance.societeCourante.PeriodeActive.getMonth()+1;
        this.anneeExercice = ParametresInstance.societeCourante.PeriodeActive.getFullYear();
        this.dateEffetVirementSepa = moment().format("YYYY-MM-DD");

        this.$forceUpdate();
	}

    public enregistrer(): void {

        if (this.societeCourante == undefined) {
            return;
        }

        if (this.anneeExercice == undefined) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Vous devez saisir une année d'exercice."
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
            return;
        }

        if (this.moisExercice == undefined) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Vous devez saisir un mois d'exercice."
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
            return;
        }

        if (this.dateEffetVirementSepa == undefined) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Merci de saisir une date d'effet au virement SEPA."
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
            return;
        }

        const dateEffetVirementSepa = moment(this.dateEffetVirementSepa).toDate()
        if (dateEffetVirementSepa < moment().startOf("day").toDate()) {
            const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
                message: "Vous devez saisir une date d'effet égale ou supérieure à la date du jour."
            });
            EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
            return;
        }

        this.isLoading = true;

        const demande: DemandeFichierVirementsSepaDto = {
            Codesociete: this.societeCourante.Code,
            Annee: this.anneeExercice,
            Mois: this.moisExercice,
            DateEffet: dateEffetVirementSepa,
            MiseEnGed: true
        };

        ServicesFactoryInstance.VirementService.GetFichierVirementsSepa(demande, data => {
            const dateExercice = demande.Annee*100+demande.Mois;
            const nomDocument = `${this?.societeCourante?.Code ?? "00"}_${dateExercice}_VirementSEPA.xml`;
            this.download(data, nomDocument);
        },
            () => {
                this.isLoading = false;
                this.annuler();
            }
        );
    }

    public download(r: Blob, nomDocument: string): void {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(r, nomDocument);
            this.isLoading = false;
            this.annuler();
        } else {
            this.isLoading = false;

            const link = document.createElement("a");
            document.body.appendChild(link);

            link.href = window.URL.createObjectURL(r);
            link.download = nomDocument;
            link.click();
            this.annuler();
        }
    }

	public annuler(): void {
    	$("#modalVirementSepa").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/modalComponents/modalVirementSepa/modalVirementSepa.ts